import { render, staticRenderFns } from "./VoucherCardComponent.vue?vue&type=template&id=a31f4c6c&scoped=true&"
import script from "./VoucherCardComponent.vue?vue&type=script&lang=js&"
export * from "./VoucherCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./VoucherCardComponent.vue?vue&type=style&index=0&id=a31f4c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31f4c6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDivider,VFlex,VLayout,VProgressLinear})
